import React from 'react';

import ErrorOutline from 'assets/icons/ErrorOutline';

import './RegisterRestriction.scss';

interface RegisterRestrictionProps {
    onSignIn?: () => void;
}

const RegisterRestriction: React.FC<RegisterRestrictionProps> = ({ onSignIn }) => {
    return (
        <div className='register-restriction'>
            <div className='register-restriction__content'>
                <ErrorOutline className='register-restriction__icon' />
                <h2 className='register-restriction__title'>You are not eligible for an account</h2>
                <p className='register-restriction__description'>
                    Based on the details provided, we cannot set up an account for you at this time. Please check our
                </p>
                <a
                    className='register-restriction__link'
                    href='https://www.channel5.com/terms-and-conditions/'
                    rel='noopener noreferrer nofollow'
                    target='_blank'
                >
                    Terms and Conditions.
                </a>
            </div>
            {onSignIn && (
                <div className='register-restriction__footer'>
                    <span className='register-restriction__footer-text'>Already have an account?</span>
                    <button className='register-restriction__footer-link' onClick={onSignIn}>
                        Sign in here
                    </button>
                </div>
            )}
        </div>
    );
};

export default RegisterRestriction;
